import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import ComposeLayoutWithConfig from "./ComposeLayoutWithConfig";
import MainLayout from "./main";
import SubLayout from "./sub";
import SingleLayout from "./single";
import { jsx as _jsx } from "react/jsx-runtime";
var ComposeLayout = function ComposeLayout(props) {
  var notTabsMode = props.layoutConfig.tabsMode === false;
  if (window.__MICRO_APP_ENVIRONMENT__) {
    return /*#__PURE__*/_jsx(SubLayout, _objectSpread({}, props));
  }
  if (notTabsMode) {
    return /*#__PURE__*/_jsx(SingleLayout, _objectSpread({}, props));
  }
  return /*#__PURE__*/_jsx(MainLayout, _objectSpread({}, props));
};
var MicroAppLayout = function MicroAppLayout(props) {
  return ComposeLayoutWithConfig(props, ComposeLayout);
};
export default MicroAppLayout;